import { useState } from 'react';
import { pickCompressedImage } from 'helpers';

/*
ให้ถ่ายรูปบัตรประชาชนและถ่ายรูปคู่กับบัตรประชาชนตามตัวอย่าง
หากไม่มีบัตรประชาชน ให้ใช้ Passport แทน
*/
const useCitizenCard = () => {
  const [citizenCardFile, setCitizenCardFile] = useState();
  const [selfieFile, setSelfieFile] = useState();

  return {
    citizenCardFile,
    selfieFile,

    onCitizenCardFileChange: async (e) => {
      const _file = await pickCompressedImage(e);
      if (_file) setCitizenCardFile(_file);
    },
    onSelfieFileChange: async (e) => {
      const _file = await pickCompressedImage(e);
      if (_file) setSelfieFile(_file);
    },
  };
};

export default useCitizenCard;
